<template>
  <div class="modal-overlay" @click.self="closeModal">
    <swiper :slides-per-view="1.5" :space-between="-100" :centered-slides="true" :initial-slide="selectGiftItemIndex" :modules="modules" navigation @slideChange="onSlideChange">
      <swiper-slide v-for="(item, index) in giftItemDetail" :key="item.id">
        <div class="modal-content">
          <button class="close-btn" @click="closeModal(item.id)"><i class="bi bi-x"></i></button>
          <div class="modal-box">
            <div class="modal-header">
              <img :src="item.image" :alt="item.title" class="product-image" />
              <h3 class="modal-title">
                {{ item.title }}
                <p class="quantity" v-if="pageSrc === 'userBackpack' && item.id.includes('IPR')">{{ $t('streamingVideo.key007') }} {{ item.quantity }}</p>
              </h3>
              <div class="giftItemDetail-prices" v-if="item.price">
                <span class="current-price">NT$ {{ item.price }}</span>
                <span class="original-price" v-if="item.originalPrice">
                  {{ item.originalPrice }}
                </span>
              </div>
            </div>

            <div class="modal-footer">
              <RichContentRenderer :blocks="item.description" />
            </div>
          </div>
          <div class="card-tags promo-tag">
            <img :src="item.promoTagSrc" alt="" />
          </div>
          <div class="card-tags stock-tag" v-if="item.remainingQuantity > 0 && item.remainingQuantity < 10 && item.remainingQuantity">
            <div class="card-tag" v-html="remainingQuantity(item.remainingQuantity)"></div>
          </div>
        </div>
        <div v-if="showAddToCartButton">
          <div v-if="item.remainingQuantity === 0">
            <button class="add-cart-btn button_style_linear btn-disable">{{ $t('product-info.key015') }}</button>
          </div>
          <div v-else>
            <button class="add-cart-btn button_style_linear" @click="addToCart(item)" v-if="activeIndex === index">{{ $t('product-info.key011') }}</button>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="modal-content read-finish">
          <img src="@/assets/img/giftShop/ProductBox_icon.png" alt="" />
          <p>{{ $t('gift-shop.key006') }}</p>
          <button class="next-page-btn button_style_linear" @click="nextPage" v-show="this.currentPage !== this.totalPages">{{ $t('gift-shop.key007') }}</button>
          <button class="back-list-btn" @click="closeModal">{{ $t('gift-shop.key008') }}</button>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import RichContentRenderer from '@/components/richContent/RichContentRenderer.vue';

export default {
  name: 'giftItemMobileDetail',
  components: {
    Swiper,
    SwiperSlide,
    RichContentRenderer,
  },
  setup() {
    const modules = [Navigation, Pagination];

    return {
      modules,
    };
  },
  emits: ['updatePage', 'close', 'add-to-cart'],
  props: {
    giftItemDetail: {
      type: Object,
      required: true,
    },
    selectGiftItemIndex: {
      type: Number,
      required: null,
    },
    oldGiftItemIndex: {
      type: Number,
      required: null,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    userBackpack: {
      type: Boolean,
      default: true,
    },
    pageSrc: {
      type: String,
      default: '',
    },
    showAddToCartButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  mounted() {},
  methods: {
    onSlideChange(swiper) {
      this.activeIndex = swiper.activeIndex;
    },
    closeModal(productId) {
      this.$emit('close', this.activeIndex, productId);
    },
    addToCart(item) {
      this.$emit('add-to-cart', item);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.closeModal();
        this.$emit('updatePage', this.currentPage + 1);
      }
    },
    remainingQuantity(itemQuantity) {
      return this.$t('shopping-cart.addOn_key010', {
        quantity: `<span class='current_price'> ${itemQuantity} </span>`,
      });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);

  .modal-content {
    background: #232323;
    border-radius: 8px;
    width: 100%;
    min-height: 60vh;
    max-height: 60vh;
    margin-top: 10vh;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    position: relative;

    .card-tags.promo-tag {
      position: absolute;
      display: flex;
      max-width: 45%;
      top: -1px;
      left: -2%;

      img {
        width: 100%;
      }
    }
  }
  .modal-box {
    padding: 12px;
    overflow-y: auto;
  }
  .card-tags.stock-tag {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 16px;
    letter-spacing: normal;
    width: 100%;
  }
  .card-tag {
    padding: 3px 0;
    font-weight: 500;
    text-align: center;
    background-color: #e2736b;
    border-radius: 0 0 8px 8px;
    box-shadow: 0px -10px 15px rgb(0, 0, 0, 0.5);
  }

  .modal-header {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
  }
  .modal-header img {
    width: 75%;
  }
  .modal-header h3 {
    font-weight: 500;
  }
  .modal-footer {
    padding-bottom: 20px;
  }
  .modal-footer p {
    font-size: 1.25em;
  }

  .close-btn {
    background: #000;
    cursor: pointer;
    position: absolute;
    right: -20px;
    top: -20px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding-bottom: 3px;
  }
  .close-btn i {
    transform: scale(1.8);
    letter-spacing: 0rem;
  }
  .modal-title {
    width: 100%;
    border-bottom: 1px solid #9a9a9a;
    margin: 10px 0;
    padding-bottom: 10px;
  }

  .giftItemDetail-prices {
    width: 100%;
    margin-bottom: 10px;
  }

  .current-price {
    color: #fff599;
    font-weight: 600;
    font-size: 1.2rem;
    margin-right: 5px;
  }

  .original-price {
    color: #9a9a9a;
    text-decoration: line-through;
    font-size: 0.8rem;
    font-weight: 400;
  }
  .add-cart-btn {
    width: 100%;
    margin-top: 10px;
    background: #232323;
  }
  .add-cart-btn.btn-disable {
    filter: grayscale(100%);
    opacity: 0.8;
  }

  .read-finish {
    background: none;
    border: none;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    img {
      max-width: 80%;
      max-height: 30vh;
    }
    p {
      font-size: 20px;
      margin: 10px 0;
      font-weight: 500;
    }
    button.next-page-btn {
      width: 90%;
      border: 1px solid #fff;
      border-radius: 5px;
      padding: 10px 0;
      margin: 10px;
      background: #232323;
    }
    button.back-list-btn {
      margin: 10px;
      font-size: 14px;
      text-decoration: underline;
      text-underline-offset: 5px;
      opacity: 0.7;
    }
  }

  .swiper {
    width: 100%;
  }
  .swiper-button-next,
  .swiper-button-prev {
    color: #ffffff;
  }

  .swiper-slide {
    transition: 0.3s all;
  }
  .swiper-slide:not(.swiper-slide-prev):not(.swiper-slide-active):not(.swiper-slide-next) {
    opacity: 0;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    transform: scale(0.9);
    filter: blur(1px) brightness(0.4);
  }

  .swiper-slide-active {
    transition: 0.3s all;
    opacity: 1;
    z-index: 10;
  }
  .quantity {
    display: inline;
    text-align: center;
    font-size: 12px;
    color: #fff599;
  }
}
</style>
